// extracted by mini-css-extract-plugin
module.exports = {"dragHandle":"Reorder_dragHandle__ENn03","gray":"Reorder_gray__wj7Pj"};